import type { ReleaseNote } from '../../shared/config/releaseNotes'
import { RELEASE_NOTES } from '../../shared/config/releaseNotes'
import { t } from '../../shared/config/translations'
import { escapeHtml } from '../utils/html'

export function releaseNotesDialogContentTemplate(note: ReleaseNote): string {
	return `
		<section class="release-notes-dialog-content">
			<p class="release-notes-eyebrow">${t('releaseNotes.newRelease')}</p>
			<h3>${releaseNoteVersionTemplate(note)}</h3>
			<p class="release-note-meta">${releaseNoteMetaTemplate(note)}</p>
			<p class="f secondary">${escapeHtml(note.summary)}</p>
			${releaseNoteItemsTemplate(note)}
			<p class="release-notes-footer">
				${t('releaseNotes.footerPrefix')}
				<a href="/settings" data-release-notes-settings-link>${t('releaseNotes.footerLink')}</a>.
			</p>
		</section>
	`
}

export function releaseNotesOverviewTemplate(): string {
	if (!RELEASE_NOTES.length) {
		return `<p class="f secondary">${t('releaseNotes.empty')}</p>`
	}

	return `
		<p class="f secondary">${t('releaseNotes.intro')}</p>
		<div class="release-notes-list">
			${RELEASE_NOTES.map(releaseNoteTemplate).join('')}
		</div>
	`
}

function releaseNoteTemplate(note: ReleaseNote): string {
	return `
		<article class="release-note">
			<header>
				<h3>${releaseNoteVersionTemplate(note)}</h3>
				<p class="release-note-meta">${releaseNoteMetaTemplate(note)}</p>
			</header>
			<p class="f secondary">${escapeHtml(note.summary)}</p>
			${releaseNoteItemsTemplate(note)}
		</article>
	`
}

function releaseNoteItemsTemplate(note: ReleaseNote): string {
	return `
		<ul class="settings-overlay-list release-note-items">
			${note.items.map((item) => `<li>${escapeHtml(item)}</li>`).join('')}
		</ul>
	`
}

function releaseNoteVersionTemplate(note: ReleaseNote): string {
	return `Version ${escapeHtml(note.version)}`
}

function releaseNoteMetaTemplate(note: ReleaseNote): string {
	return `${escapeHtml(note.date)} - ${escapeHtml(note.title)}`
}
